import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import Dashboard from '../pages/StudentDashboard/Dashboard.js';
import Applications from '../pages/ReveiwerDashboard/Applications.js';
import Report from '../pages/ReveiwerDashboard/Report.js';
import EditProfile from '../components/EditProfile';
import Layout from "../layout/index.js";
import ChangePassword from "../components/ChangePassword/index.js";
import Students from "../pages/SuperAdmin/Students.js";
import AllApplications from "../pages/SuperAdmin/Applications.js";
import ReportDashboard from "../components/Reports/index.js";
import GpaWarnings from "../pages/SuperAdmin/GpaWarnings.js";
import ApprovalTracker from "../pages/SuperAdmin/ApprovalTracker.js";

const ApproverRoutes = () => {
  const permissions = useSelector((state) => state.mainSlice.userdetail?.permissions) || [];

  const routesData = useMemo(() => {
    const base = [
      { path: "", element: <Dashboard />, text: "Dashboard" },
      { path: "application", element: <Applications role="approver" />, text: "Review Applications" },
      { path: "report", element: <Report />, text: "Report" },
      { path: "gpa-warnings", element: <GpaWarnings />, text: "GPA Warnings" },
      { path: "approval-tracker", element: <ApprovalTracker />, text: "Approval Tracker" },
    ];
    if (permissions.includes("view_students"))
      base.push({ path: "students", element: <Students readOnly />, text: "Students" });
    if (permissions.includes("view_all_applications"))
      base.push({ path: "all-applications", element: <AllApplications readOnly />, text: "All Applications" });
    if (permissions.includes("view_reports"))
      base.push({ path: "reports", element: <ReportDashboard />, text: "Reports" });
    return base;
  }, [permissions]);

  return (
    <Routes>
      <Route path="/" element={<Layout navItems={routesData} />}>
        {routesData.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
};

export default ApproverRoutes;